const scrollIntoView = (id: string): void => {
	const target = document.getElementById(id)

	if (target) {
		window.scrollTo({
			top: target.offsetTop - 16,
			behavior: 'smooth',
		})
	}
}

export default scrollIntoView
